<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">我的订单</h3>
    <el-tabs v-model="activeName">
      <el-tab-pane label="全部订单" name="0" lazy>
        <order-list :status="0"></order-list>
      </el-tab-pane>
      <el-tab-pane label="待支付" name="1" lazy>
        <order-list :status="1"></order-list>
      </el-tab-pane>
      <el-tab-pane label="待发货" name="2" lazy>
        <order-list :status="2"></order-list>
      </el-tab-pane>
      <el-tab-pane label="待收货" name="3" lazy>
        <order-list :status="3"></order-list>
      </el-tab-pane>
      <el-tab-pane label="已完成" name="4" lazy>
        <order-list :status="4"></order-list>
      </el-tab-pane>
      <el-tab-pane label="已关闭" name="5" lazy>
        <order-list :status="5"></order-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OrderList from './myOrderList';
export default {
  data() {
    return {
      activeName: 0,
      searchValue: ''
    };
  },
  // 注册组件
  components: {OrderList},
  mounted() {
    if (this.$route.fullPath.indexOf('tap') > 0) {
      this.activeName = this.$route.query.tap
    }
  },
  methods: {
    // 搜索功能
    searchHandle(value) {
      this.getshoworderList(this.activeName, value)
    },
    nextEditResource() {
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {
          if (this.sizeForm.checkedBox) {
            this.errerInfo = false;
            this.$router.push(`/merchantForm?type=${this.$route.query.type}`)
          } else {
            this.errerInfo = true;
          }
        }
      });
    }

  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    color: #666;
  }
  .search_box {
    text-align: right;
    margin-bottom: 10px;
    .input-with-select.el-input.el-input-group.el-input-group--append {
      width: 40%;
    }
  }





  .tab_pane_content {
    .noData {
      text-align: center;
      height: 200px;
      line-height: 200px;
    }
  }

}

// }
.pagination {
  text-align: right;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;
    color: #FFF;
    width: 20px;
  }

  /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .el-pager li {
    width: 20px;
  }

  /deep/ input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
    background-color: transparent;
  }
}

</style>







// WEBPACK FOOTER //
// src/views/myOrder/myOrder.vue